/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speechmatics_Target_Language_DanishInputs */

const en_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danish`)
};

const fr_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danois`)
};

const de_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dänisch`)
};

const it_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`danese`)
};

const ru_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`датский`)
};

const es_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`danés`)
};

const zh_cn2_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`丹麦语`)
};

const ja_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デンマーク語`)
};

const hi_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`डेनिश`)
};

const pt_pt2_speechmatics_target_language_danish = /** @type {(inputs: Speechmatics_Target_Language_DanishInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dinamarquês`)
};

/**
* | output |
* | --- |
* | "Danish" |
*
* @param {Speechmatics_Target_Language_DanishInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speechmatics_target_language_danish = /** @type {((inputs?: Speechmatics_Target_Language_DanishInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speechmatics_Target_Language_DanishInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speechmatics_target_language_danish(inputs)
	if (locale === "de") return de_speechmatics_target_language_danish(inputs)
	if (locale === "it") return it_speechmatics_target_language_danish(inputs)
	if (locale === "ru") return ru_speechmatics_target_language_danish(inputs)
	if (locale === "es") return es_speechmatics_target_language_danish(inputs)
	if (locale === "zh-CN") return zh_cn2_speechmatics_target_language_danish(inputs)
	if (locale === "ja") return ja_speechmatics_target_language_danish(inputs)
	if (locale === "hi") return hi_speechmatics_target_language_danish(inputs)
	if (locale === "pt-PT") return pt_pt2_speechmatics_target_language_danish(inputs)
	return en_speechmatics_target_language_danish(inputs)
});